
function updateActiveState() {
  const activeTypeBtn = document.querySelector('.flexible_variable .type-btn.active');
  const activeDateContainer = document.querySelector('.desktop_choose-dates.active');
  const dateSelect = document.getElementById('date-options');

  if (!activeTypeBtn || !dateSelect || !activeDateContainer) return;

  // ✅ Get date from selected-date span OR active date-btn
  let activeDate = '';
  
  // Method 1: From .selected-date span (for trigger button)
  const selectedDateSpan = activeDateContainer.querySelector('.selected-date');
  if (selectedDateSpan) {
    activeDate = selectedDateSpan.dataset.selected || selectedDateSpan.textContent.trim();
  }
  
  // Method 2: From active date-btn (for radio options)
  if (!activeDate) {
    const activeDateBtn = activeDateContainer.querySelector('.date-btn.active');
    if (activeDateBtn) {
      activeDate = activeDateBtn.dataset.date;
    }
  }

  // Method 3: From checked radio input
  if (!activeDate) {
    const checkedInput = activeDateContainer.querySelector('input[type="radio"]:checked');
    if (checkedInput) {
      activeDate = checkedInput.value;
    }
  }

  //console.log('Active Date:', activeDate); // Debug

  if (!activeDate) return;

  const activeType = activeTypeBtn.dataset.type.toLowerCase();

  const matchingOption = Array.from(dateSelect.options).find(opt => opt.dataset.date === activeDate);
  if (!matchingOption) return;

  if (dateSelect.value !== matchingOption.value) {
    dateSelect.value = matchingOption.value;
    dateSelect.dispatchEvent(new Event('change', { bubbles: true }));
  }

  const optionTitle = matchingOption.dataset.varTitle;
 // console.log('optionTitle', optionTitle);
  
  const buttonLabel = document.querySelector(
    `variant-selects[data-id="variant-selects-id"] .product-form__input label[data-title="${optionTitle}"]`
  );

  if (buttonLabel && !buttonLabel.classList.contains('checked-programmatically')) {
    buttonLabel.classList.add('checked-programmatically');
    buttonLabel.click();
    setTimeout(() => buttonLabel.classList.remove('checked-programmatically'), 200);
  }
   setTimeout(function() {
    initDepoListeners();
  }, 2000);
  
}

function handleTypeChange(btn) {
  document.querySelectorAll('.type-btn').forEach(b => b.classList.remove('active'));
  btn.classList.add('active');

  const type = btn.dataset.type.toLowerCase();
  document.querySelectorAll('.choose-dates, .tab_text').forEach(container => {
    const isMatch = container.dataset.type.toLowerCase() === type;
    container.classList.toggle('active', isMatch);
  });

  updateActiveState();
}

// ✅ NEW: Handle date selection from dropdown
function handleDateSelection(input) {
  const container = input.closest('.desktop_choose-dates');
  if (!container) return;

  // Update all date-btn labels
  container.querySelectorAll('.date-btn').forEach(btn => btn.classList.remove('active'));
  
  // Add active to selected label
  const label = container.querySelector(`label[for="${input.id}"]`);
  if (label) {
    label.classList.add('active');
  }

  // Update trigger button display
  const trigger = container.querySelector('.selected-date');
  if (trigger) {
    trigger.dataset.selected = input.value;
    trigger.textContent = input.value;
  }

  // Update title if exists
  const titleSpan = container.querySelector('.selected-title');
  const varId = input.dataset.varId;
  if (titleSpan && varId) {
    titleSpan.textContent = varId;
  }

  updateActiveState();
}

function initializeListeners() {
  // Type buttons
  document.querySelectorAll('.flexible_variable .type-btn').forEach(btn => {
    btn.addEventListener('click', () => handleTypeChange(btn));
  });

  // ✅ Date radio inputs
  document.querySelectorAll('.desktop_choose-dates input[type="radio"]').forEach(input => {
    input.addEventListener('change', () => handleDateSelection(input));
  });

 
}

document.addEventListener('DOMContentLoaded', () => {
  initializeListeners();
  // ✅ Small delay for initial call to let Shopify initialize first
  setTimeout(() => {
    updateActiveState();
  }, 100);
});


function initCustomSelects() {
  document.querySelectorAll('.custom-select-wrapper').forEach(wrapper => {
    if (wrapper.dataset.initialized) return; // run only once
    wrapper.dataset.initialized = "true";

    const trigger = wrapper.querySelector('.custom-select-trigger');
    const options = wrapper.querySelector('.custom-options');
    if (!options) return;

    const radios = options.querySelectorAll('input[type="radio"]');
    trigger?.addEventListener('click', e => {
      e.stopPropagation();
      const isOpen = options.classList.toggle('options_show');
      if (isOpen) {
        trigger.classList.add('button_active');
      } else {
        trigger.classList.remove('button_active');
      }
     
    });

    document.addEventListener('click', () => {
     if (options) options.classList.remove('options_show');
     if (trigger) trigger.classList.remove('button_active');
    });

    radios.forEach(radio => {
      const li = radio.closest('.custom-radio-option');

      li.addEventListener('click', e => {
        e.stopPropagation();

        // Update variant input (if exists)
        const optionValueId = radio.dataset.varId;
        const variantInput = document.querySelector(
          `variant-selects[data-id="variant-selects-id"] .product-form__input label[data-title="${optionValueId}"]`
        );
        if (variantInput) variantInput.click();

        // Identify type of this box (Online/Hybrid)
        const boxType = wrapper.closest('.choose-dates')?.dataset.type || 'Unknown';

        // Update current wrapper button
        const displaySpan = wrapper.querySelector('.selected-date');
        const displayTitle = wrapper.querySelector('.selected-title');
        if (displaySpan) displaySpan.textContent = radio.value;
        if (displayTitle)
          displayTitle.textContent = li.querySelector('.variant_Online_name span:last-child')?.textContent;

        // Also update mobile/desktop wrapper of same type
        const mobileWrapper = document.querySelector(`.choose-dates.mobile_program_select[data-type="${boxType}"]`);
        if (mobileWrapper) {
          const mSpan = mobileWrapper.querySelector('.selected-date');
          const mTitle = mobileWrapper.querySelector('.selected-title');
          if (mSpan) mSpan.textContent = radio.value;
          if (mTitle) mTitle.textContent = li.querySelector('.variant_Online_name span:last-child')?.textContent;
        }

        const desktopWrapper = document.querySelector(`.choose-dates.desktop_choose-dates[data-type="${boxType}"]`);
        if (desktopWrapper) {
          const dSpan = desktopWrapper.querySelector('.selected-date');
          const dTitle = desktopWrapper.querySelector('.selected-title');
          if (dSpan) dSpan.textContent = radio.value;
          if (dTitle) dTitle.textContent = li.querySelector('.variant_Online_name span:last-child')?.textContent;
        }

        // Close dropdown
        options.classList.remove('options_show');
      });
    });
  });
}

function isMobile() {
  return window.innerWidth <= 750;
}


const triggers = document.querySelectorAll('.custom-select-trigger');

// Trigger click event to add active_toggle class
triggers.forEach(trigger => {
  trigger.addEventListener('click', e => {
    e.stopPropagation();  
if (!isMobile()) return; 
    const chooseDatesContainer = trigger.closest('.product');
    if (chooseDatesContainer) {
      const type = trigger.closest('.choose-dates').getAttribute('data-type');
      const selectedSection = document.querySelector(`.mobile_program_select[data-type="${type}"] .toggle_mobile_program_select`);
      
      // Add active_toggle class to the selected section
      if (selectedSection) {
        selectedSection.classList.add('active_toggle');
       
      }
       document.body.classList.add('modal-open');
    }
  });
});

// Close button logic: remove active_toggle class when clicking close button
const closeButtons = document.querySelectorAll('.choose-dates_modal__toggle.toggle-close_button, .select_dates_button');
closeButtons.forEach(button => {
  button.addEventListener('click', () => {
    // Find the closest parent that is .toggle_mobile_program_select and remove active_toggle class
    const toggleSection = button.closest('.toggle_mobile_program_select');
    if (toggleSection) {
      toggleSection.classList.remove('active_toggle');
    }
     document.body.classList.remove('modal-open');
  });
});

function updateAllButtons(dateValue, titleValue) {
  document.querySelectorAll('.custom-select-wrapper .selected-date')
    .forEach(el => el.textContent = dateValue);

  document.querySelectorAll('.custom-select-wrapper .selected-title')
    .forEach(el => el.textContent = titleValue);
}

document.addEventListener('DOMContentLoaded', initCustomSelects);

window.addEventListener('resize', function() {
  initCustomSelects();
});

document.addEventListener('click', function (event) {
  function initPopupModals() {
    const buttons = document.querySelectorAll('.custom_product-popup-modal__opener');

    buttons.forEach((button) => {
      const modalSelector = button.dataset.modal;
      const modal = document.querySelector(modalSelector);

      if (!modal) return;

      // Open modal on button click
      button.addEventListener('click', (event) => {
        modal.classList.add('active');
        document.body.classList.add('modal-open');
      });

      // Close modal on close button click inside modal
      const closeBtns = modal.querySelectorAll('.custom_product-popup-modal__toggle');
      if (closeBtns.length > 0) {
        closeBtns.forEach((closeBtn) => {
          closeBtn.addEventListener('click', () => {
            modal.classList.remove('active');
            document.body.classList.remove('modal-open');
          });
        });
      }

      // Close modal when clicking outside modal content (on the overlay)
      modal.addEventListener("click", function (e) {
        if (e.target === modal) {
          modal.classList.remove('active');
          document.body.classList.remove('modal-open');
        }
      });
    });
  }

  // Call this after DOM is ready
  initPopupModals();
});


 // Listen for changes on any radio button with the name 'purchase_option'
  // document.querySelectorAll('input[name="purchase_option"]').forEach(input => {
  //   input.addEventListener('change', function () {
  //     // Remove the "active" class from all payment cards
  //     document.querySelectorAll('.payment-card').forEach(card => {
  //       card.classList.remove('active');
  //     });

  //     // Add the "active" class to the selected payment card
  //     const selectedPaymentCard = this.closest('.payment-card');
  //     if (selectedPaymentCard) {
  //       selectedPaymentCard.classList.add('active');
  //     }
  //   });
  // });

  const sliderWrappers = document.querySelectorAll('.popup-slider-wrapper');

  sliderWrappers.forEach(wrapper => {
    const slides = wrapper.querySelectorAll('.popup-slide');
    const dots = wrapper.nextElementSibling?.querySelectorAll('.dot'); // Dots container is after wrapper
    let currentIndex = 0;

    if (slides.length === 0) return;

    // Show the first slide
    slides[currentIndex].classList.add('active');
    if (dots && dots[currentIndex]) dots[currentIndex].classList.add('active');

    // Function to show a slide by index
    const showSlide = (index) => {
      slides.forEach((slide, i) => slide.classList.toggle('active', i === index));
      if (dots) dots.forEach((dot, i) => dot.classList.toggle('active', i === index));
      currentIndex = index;
    };

    // Dot click event
    if (dots) {
      dots.forEach((dot, i) => {
        dot.addEventListener('click', () => showSlide(i));
      });
    }

    // Optional: Swipe support for mobile
    let startX = 0;
    let endX = 0;
    wrapper.addEventListener('touchstart', e => startX = e.touches[0].clientX);
    wrapper.addEventListener('touchend', e => {
      endX = e.changedTouches[0].clientX;
      if (startX - endX > 50) nextSlide();   // swipe left
      if (endX - startX > 50) prevSlide();   // swipe right
    });

    // Next / previous functions
    const nextSlide = () => showSlide((currentIndex + 1) % slides.length);
    const prevSlide = () => showSlide((currentIndex - 1 + slides.length) % slides.length);

    // Optional: Auto slide
    // setInterval(nextSlide, 5000); // Uncomment to auto-slide every 5 seconds
  });
 


document.addEventListener("DOMContentLoaded", function () {

  function getBoxes() {
    return {
      fullBox: document.querySelector(".full_Price"),
      installmentBox: document.querySelector(".Installments_box"),
      depositBox: document.querySelector(".Deposit_box")
    };
  }

  function hideAll() {
    const { fullBox, installmentBox, depositBox } = getBoxes();
    if (fullBox) fullBox.style.display = "none";
    if (installmentBox) installmentBox.style.display = "none";
    if (depositBox) depositBox.style.display = "none";
  }

  function getPlanNameFromRadio(radio) {
    return (
      radio.dataset.name ||
      radio.closest(".depo-group")?.querySelector(".depo-group-label")?.innerText ||
      radio.closest(".depo-one-time-purchase-option")?.querySelector("label")?.innerText ||
      "full"
    );
  }

  function showByPlan(planName) {
    const { fullBox, installmentBox, depositBox } = getBoxes();
    hideAll();

    const plan = planName.toLowerCase();

    if (plan.includes("deposit")) {
      if (depositBox) depositBox.style.display = "block";
    }
    else if (plan.includes("installment")) {
      if (installmentBox) installmentBox.style.display = "block";
    }
    else {
      if (fullBox) fullBox.style.display = "block";
    }
  }

  /* ✅ PAGE LOAD – wait till Depo injects HTML */
  const loadInterval = setInterval(() => {
    const checkedRadio = document.querySelector(
      'input[name="apt_purchase_option"]:checked'
    );

    if (checkedRadio && document.querySelector(".full_Price")) {
      showByPlan(getPlanNameFromRadio(checkedRadio));
      clearInterval(loadInterval);
    }
  }, 300);

  /* ✅ CLICK / CHANGE */
  document.addEventListener("change", function (e) {
    if (!e.target.matches('input[name="apt_purchase_option"]')) return;
    showByPlan(getPlanNameFromRadio(e.target));
  });

});

   function initDepoListeners() {
    const targetInput = document.querySelector('.line-item-property__fieldsss input#lineItem');
    if (!targetInput) return;

      document.querySelectorAll('.depo-group-border-bottom input').forEach(function (item) {
          const noteEl = document.querySelector('body .custom-text-class');
          const datatext = noteEl ? noteEl.getAttribute('data-note') : '';
          if (item.dataset.depoInit === 'true') return;
          item.dataset.depoInit = 'true';
          
          item.addEventListener('change', function () {
              //console.log('Holosomatic');
              const dataName = this.getAttribute('data-name');
              if (dataName === 'Deposit') {
                  targetInput.value = datatext;
              } else {
                  targetInput.value = '';
              }
              //console.log(targetInput.value);
          });
      });
    }

    // Observe DOM changes
    const depoObserver = new MutationObserver(function () {
    const depoInputs = document.querySelectorAll('.depo-group-border-bottom input');
      if (depoInputs.length) {
      initDepoListeners();
      }
    });

    document.addEventListener('DOMContentLoaded', function () {
      depoObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
      initDepoListeners();
    });
